import noThumbnailImage from "./../resources/no-thumbnail.jpg";

const ProjectItem = ({ name, desc, tags, thumbnailImage, liveLink, githubLink }) => {
  return (
    <li className="project__item">
      <figure className="project__figure">
        <img
          className="project__img"
          src={thumbnailImage ? thumbnailImage : noThumbnailImage}
          alt=""
        />
      </figure>
      <div className="project__content">
        <p className="medium-text mb-2 project__name">{name}</p>
        <ul className="project__tags mb-3 ">
          {tags.map((tag, idx) => (
            <li key={idx} className="project__tag">
              {tag}
            </li>
          ))}
        </ul>
        <p className="small-x-text mb-5">{desc}</p>
        <div className="project__btns">
          <a href={liveLink} className="btn" target="_blank" rel="noreferrer">
            Live at
          </a>
          <a href={githubLink} className="btn" target="_blank" rel="noreferrer">
            Source Code
          </a>
        </div>
      </div>
    </li>
  );
};

export default ProjectItem;
